// FAQ obsah pro feedback dialog. Zdroj: issue #873
// https://github.com/behavio/trendaro-fe/issues/873#issuecomment-4379908863
// Texty v `answer` mohou obsahovat ::BR:: (zalomení řádku) a markdown odkazy `[label](href)`.
// Renderování řeší FeedbackDialog (nepoužívá utils/sanitize).

export type FeedbackContext = "qset" | "menu";

export interface FaqItem {
  question: string;
  answer: string;
}

const QSET_FAQ: ReadonlyArray<FaqItem> = [
  {
    question: "Nefunguje mi video.",
    answer:
      "Po přehrání videa ťukněte znovu na::NBSP::šipku. Pokud šipka nereaguje, zkuste dotazník otevřít v::NBSP::prohlížeči Chrome, v::NBSP::něm zpravidla vše běží bez::NBSP::problémů.",
  },
  {
    question: "Neznám odpověď na::NBSP::otázku v::NBSP::dotazníku.",
    answer:
      "Nevadí – i::NBSP::odhad nebo neutrální odpověď jsou pro nás cenné. Můžete nechat čas vypršet, přeskočit otázku, pokud to lze, vybrat „nic z::NBSP::toho“ / „žádné z::NBSP::nich“, nebo zvolit neutrální emoci.",
  },
  {
    question: "Nevidím další otázku.",
    answer:
      "Nejčastější příčina je AdBlock – zkuste ho pro Trendaro vypnout a::NBSP::stránku obnovit.",
  },
  {
    question: "Nejde mi to přiřadit.",
    answer:
      "Ťukněte na::NBSP::spojení nahoře (označí::NBSP::se), pak ťukněte na::NBSP::tlačítko dole, kam patří – tím je propojíte. Takto projděte všechna spojení a::NBSP::dotazník vás posune dál. Pokud otázka nereaguje, zkuste dotazník otevřít v::NBSP::prohlížeči Chrome.",
  },
  {
    question: "Nefunguje mi to.",
    answer:
      "Zkuste dotazníky otevřít v::NBSP::prohlížeči Chrome – tam Trendaro funguje téměř vždy bez::NBSP::potíží.",
  },
];

const MENU_FAQ: ReadonlyArray<FaqItem> = [
  {
    question: "Mám málo dotazníků. Co s::NBSP::tím?",
    answer:
      "Každý dotazník míří na::NBSP::konkrétní skupinu lidí – pokud do::NBSP::ní nespadáte, nepřijde vám. Někdy tak přijde víc setů naráz, jindy jeden za::NBSP::čas. Pokud vám ale nepřišel žádný dotazník déle než měsíc, napište nám – rádi se na::NBSP::to podíváme.",
  },
  {
    question: "Kdy mi přijdou peníze na účet?",
    answer:
      "Odměny za prodaná stáda odesíláme každý čtvrtek, na::NBSP::účtu bývají v::NBSP::pátek.",
  },
  {
    question: "Proč mi nejde prodat stádo?",
    answer:
      "Stádo musí mít aspoň 500::NBSP::prasátek. Před prvním prodejem je také potřeba telefonické ověření – bez něj odměnu poslat nemůžeme.",
  },
  {
    question: "Jak získat apku do::NBSP::telefonu?",
    answer:
      "Nejlepší je mít vždy nejnovější verzi. Pokud máte starší apku, smažte ji a::NBSP::nainstalujte znovu podle návodu:::BR::- otevřete si prohlížeč Chrome (nemáte-li, stáhněte si ho prosím)::BR::- jděte na::NBSP::[moje.trendaro.cz](https://moje.trendaro.cz)::BR::- klikněte na::NBSP::tři tečky vpravo od::NBSP::adresy stránky::BR::- vyberte „Přidat na::NBSP::plochu“ nebo „Odeslat, uložit a::NBSP::sdílet“ a::NBSP::následně „Stáhnout aplikaci Trendaro“::BR::- ve staženém Trendaru si pak ještě zapněte notifikace, které vidíte hned po::NBSP::přihlášení.",
  },
  {
    question: "Jak si opravit adresu nebo jiné údaje?",
    answer: "Můžete si je opravit v::NBSP::sekci [Nastavení](/settings).",
  },
  {
    question: "Neptáte se na::NBSP::moc osobní věci?",
    answer:
      "Chápeme, že některé otázky mohou působit osobně. Data zpracováváme hromadně a::NBSP::anonymně – zajímají nás vzorce a::NBSP::souvislosti, ne konkrétní lidé. Takhle třeba vypadají naše zjištění o::NBSP::[lidech, kteří mají psa](https://atlascechu.cz/results/pet-dog) – a::NBSP::podobně pracujeme i::NBSP::s::NBSP::jinými odpověďmi. Vaše otevřenost je pro naši práci zásadní.",
  },
  {
    question: "Jak můžu pozvat kamaráda?",
    answer:
      "Přátelé se mohou registrovat přes odkaz [moje.trendaro.cz](https://moje.trendaro.cz), ale nedostanete za::NBSP::ně žádnou odměnu. Placené pozvánky v::NBSP::tuto chvíli nejsou k::NBSP::dispozici.",
  },
];

export const FAQ_ITEMS: Record<FeedbackContext, ReadonlyArray<FaqItem>> = {
  qset: QSET_FAQ,
  menu: MENU_FAQ,
};
